module.exports = __webpack_public_path__ + "img/BDT.505b2d1b.svg";